
  <div class="row Page-Header">
    <div class="col-8">
      <h6 class="HeadContent">Change Subject Display Order</h6>
    </div>
    <div class="col-4 d-flex flex-row-reverse">
        <div class="px-1">
          <button type="button"  class="close" (click)="cancel()" style="font-size: 26px">
            <span aria-hidden="true">&times;</span></button>
        </div>
       
    </div>
  </div>
  <div class="col-12 d-flex">
    <div class="pl-1 pt-1">Target Location:</div>
    <div class="p-0"><app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb></div>
  </div>
 
<!-- <div class="row"  *ngIf="SDOInput" style="min-height: 70vh !important;max-height: 70vh !important;overflow: scroll;margin: 2px; margin-top: 10px;">
  <div class="col-12" *ngIf="subject">
    <div class="row">
      <div class="col-12 Px-2"  [sortablejs]="subject" [sortablejsOptions]="draggableOptions">
        <div class="row border invRow p-1"  *ngFor="let s of subject | sortBy:sortParam:'asc';let i=index;" (drag)="getData('drag')" [class.draggable]="isdraggable" [class.disabled]="isdraggable">
          <div class="col-12 d-flex px-1 SubConcept6">
            <div  class="px-1">
              {{s.Name}}
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</div> -->

<div class="row"  *ngIf="SDOInput" style="min-height: 70vh !important;max-height: 70vh !important;overflow: scroll;margin: 2px; margin-top: 10px;">
  <div class="col-12" *ngIf="subject">
    <div class="row">
      <div cdkDropList
 (cdkDropListDropped)="onDrop($event)"
 [cdkDropListData]="subject">
    <div cdkDrag class="drag-item listitem" *ngFor="let s of subject;let i=index;">
        {{s.Name}}
    </div>
 </div>
    </div>
</div>
</div>
<div class="row py-2">
  <div class="col-12 py-1 d-flex" *ngIf="subject">
    <div class="px-1">
      <button type="button" [disabled]="subject.length==1||!Savebutton" class="btn btn-sm bl-btn" (click)="updateReorder()">Save</button>
    </div>
 
    <div class="px-1">
      <button type="button" class="btn btn-sm bg-light border" (click)="cancel()">Cancel</button></div>   
  </div>
</div>
